export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '937c6911-b5df-42db-af4f-00171f85df99';
export const MODAL_CLOSE_SEC = 2.5;
